import styled from 'styled-components';
import Btn022 from 'dc/Btn022';
import { Typ71 } from 'dc/Typ';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-bottom: 64px;
`;

export const BackButton = styled(Btn022)`
  align-self: flex-start;
  margin: 12px 0 8px;
`;

export const MenuWrapper = styled.div`
  padding: 44px 40px 36px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #fff;
  border-radius: 5px;
`;

export const Header = styled(Typ71)`
  padding-left: 24px;
  margin-bottom: 32px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
